var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgEdge = function SvgEdge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__b)",
    d: "M14.444 11.906c-.215.112-.436.21-.663.294a6.366 6.366 0 0 1-2.244.4c-2.956 0-5.53-2.031-5.53-4.644A1.969 1.969 0 0 1 7.03 6.25c-2.675.112-3.362 2.9-3.362 4.531 0 4.625 4.256 5.088 5.175 5.088.494 0 1.237-.144 1.687-.288l.082-.025a8.019 8.019 0 0 0 4.162-3.3.25.25 0 0 0-.331-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__c)",
    d: "M14.444 11.906c-.215.112-.436.21-.663.294a6.366 6.366 0 0 1-2.244.4c-2.956 0-5.53-2.031-5.53-4.644A1.969 1.969 0 0 1 7.03 6.25c-2.675.112-3.362 2.9-3.362 4.531 0 4.625 4.256 5.088 5.175 5.088.494 0 1.237-.144 1.687-.288l.082-.025a8.019 8.019 0 0 0 4.162-3.3.25.25 0 0 0-.331-.35Z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__d)",
    d: "M6.606 15.081a4.952 4.952 0 0 1-1.418-1.331 5.044 5.044 0 0 1 1.843-7.5c.2-.094.532-.256.975-.25a2.025 2.025 0 0 1 1.607.813c.251.338.389.747.393 1.168 0-.012 1.531-4.975-5-4.975-2.744 0-5 2.6-5 4.888a8.138 8.138 0 0 0 .757 3.5 8 8 0 0 0 9.774 4.187 4.72 4.72 0 0 1-3.925-.5h-.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__e)",
    d: "M6.606 15.081a4.952 4.952 0 0 1-1.418-1.331 5.044 5.044 0 0 1 1.843-7.5c.2-.094.532-.256.975-.25a2.025 2.025 0 0 1 1.607.813c.251.338.389.747.393 1.168 0-.012 1.531-4.975-5-4.975-2.744 0-5 2.6-5 4.888a8.138 8.138 0 0 0 .757 3.5 8 8 0 0 0 9.774 4.187 4.72 4.72 0 0 1-3.925-.5h-.006Z",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__f)",
    d: "M9.525 9.3c-.056.063-.213.156-.213.35 0 .162.107.325.3.456.894.625 2.588.538 2.594.538.667 0 1.32-.18 1.894-.519A3.837 3.837 0 0 0 16 6.819c.019-1.4-.5-2.332-.706-2.744C13.962 1.487 11.106 0 8 0a8 8 0 0 0-8 7.888c.031-2.282 2.3-4.125 5-4.125.219 0 1.469.018 2.625.625a4.538 4.538 0 0 1 1.931 1.83c.382.663.45 1.507.45 1.845 0 .337-.168.83-.487 1.243l.006-.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__g)",
    d: "M9.525 9.3c-.056.063-.213.156-.213.35 0 .162.107.325.3.456.894.625 2.588.538 2.594.538.667 0 1.32-.18 1.894-.519A3.837 3.837 0 0 0 16 6.819c.019-1.4-.5-2.332-.706-2.744C13.962 1.487 11.106 0 8 0a8 8 0 0 0-8 7.888c.031-2.282 2.3-4.125 5-4.125.219 0 1.469.018 2.625.625a4.538 4.538 0 0 1 1.931 1.83c.382.663.45 1.507.45 1.845 0 .337-.168.83-.487 1.243l.006-.006Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.9625 0 0 5.66437 9.825 11.147)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.3425 -8.8605 7.15839 1.0846 4.41 12.434)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(92.291 -.612 2.256) scale(12.6601 26.9634)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.70275 5.838 -4.74746 1.38468 15.004 4.831)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge_svg__b",
    x1: 3.669,
    x2: 14.819,
    y1: 11.063,
    y2: 11.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge_svg__d",
    x1: 9.544,
    x2: 2.587,
    y1: 6.225,
    y2: 13.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "edge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdge);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;